import React, { useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { sr, actAs } from "../../lib/sr";

// Deep link from a "client assigned to you" notification/email — starts acting-as
// the client and drops the manager straight into that account.
export default function ActAsRedirect() {
  const { tid } = useParams();
  const nav = useNavigate();
  const ran = useRef(false);
  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    (async () => {
      try {
        const r = await sr.adminActAs(tid);
        actAs.set({ tenant_id: tid, name: r.name });
        toast.success(`Now managing ${r.name || "the client"}`);
        nav("/app/home", { replace: true });
      } catch (e) {
        toast.error(e?.response?.data?.detail || "Couldn't open that client — it may not be assigned to you.");
        nav("/app/my-clients", { replace: true });
      }
    })();
  }, [tid, nav]);
  return (
    <div className="sr-empty" style={{ padding: 60, textAlign: "center" }} data-testid="act-as-redirect">
      <Loader2 className="sr-spin" /> <span style={{ marginLeft: 8 }}>Opening the client account…</span>
    </div>
  );
}
